import { config, executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const bulkRefundProcessReq = (req: any, userAccessToken: string, id: any) => {
  const request: Request<{}> = {
    config: config.mockable2,
    apiPath: id === 'process' ? APIEndPoints.InitiateBulkRefund : APIEndPoints.deleteBulkRefund,
    method: id === 'process' ? 'GET' : 'POST',
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { bulkRefundProcessReq }
